/**
 *
 * Gets the html for a spinner
 * @deprecated Please use the Spinner class
 *
 * @param {string} color
 * @param {string} size
 * @returns {Element} The spinner
 */
export function spinner(color = 'primary', size = 'sm') {
    return new Spinner(color, size);
}

/**
 * Creates a spinner
 *
 */
export class Spinner {
    constructor(color = 'primary', size = 'sm') {
        this.color = color;
        this.size = size;

        this.spinner = this.createSpinner();

        return this.spinner;
    }

    /**
     * Generates a spinner
     *
     * @returns {mixed} The spinner
     */
    createSpinner() {
        const spinner = document.createElement('span');
        spinner.innerHTML = `<div role="status" class="spinner-border spinner-border-${this.size} text-${this.color}"></div>`;

        return spinner;
    }

    /**
     * Alters the spinner to a success icon
     *
     * @param {Element} spinner
     */
    static animationSuccess(spinner, successAction = false) {
        const checkIcon = document.createElement('i');
        checkIcon.classList.add('fa-solid', 'fa-check', 'pop-lg');

        if (successAction) {
            spinner.addEventListener('animationend', successAction);
        }

        spinner.innerHTML = checkIcon.outerHTML;
    }
}

window.spinner = function (color, size) {
    return new Spinner(color, size);
};
